export default __webpack_public_path__ + "static/plans-bf26b649ee3de661797a78db8386eddc.png";